(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gg-jul-early-gift"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('gg-jul-early-gift'))customElements.define('gg-jul-early-gift',class extends HTMLElement{
connectedCallback(){if(this.events)return;this.events=new AbortController();this.addEventListener('submit',event=>{if(!event.target.matches('.jeg-form'))return;event.preventDefault();this.addGift(event.target)},{signal:this.events.signal})}
async addGift(form){if(form.dataset.submitting)return;const button=form.querySelector('button'),status=form.querySelector('.jeg-status'),body=new FormData(form),root=window.Shopify?.routes?.root||'/';form.dataset.submitting='true';form.setAttribute('aria-busy','true');button.disabled=true;status.hidden=true;try{const response=await fetch(root+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body});const result=await response.json();if(!response.ok||result.status)throw new Error(result.description||status.dataset.error);let cart;try{const response=await fetch(root+'cart.js',{headers:{Accept:'application/json'},cache:'no-store'});if(response.ok)cart=await response.json()}catch{}document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:cart,sourceId:body.get('id'),data:{source:'gg-jul-early-gift',variantId:body.get('id')}}}));status.textContent=status.dataset.success}catch(error){status.textContent=error.message||status.dataset.error}finally{status.hidden=false;button.disabled=false;form.removeAttribute('aria-busy');delete form.dataset.submitting}}
disconnectedCallback(){this.events?.abort();this.events=null}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gg-jul-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gg-season-faq-video')) {
    class SeasonFaqVideo extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.wantsPlayback = !this.motion.matches;
        this.visible = !('IntersectionObserver' in window);
        this.video.muted = true;
        this.video.addEventListener('play', () => {
          this.wantsPlayback = true;
          if (!this.visible || document.hidden) this.pausePlayback();
        }, { signal });
        this.video.addEventListener('pause', () => {
          if (!this.systemPause) this.wantsPlayback = false;
          this.systemPause = false;
        }, { signal });
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) {
            this.wantsPlayback = false;
            this.pausePlayback();
          }
        }, { signal });
        document.addEventListener('visibilitychange', () => this.updatePlayback(), { signal });
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.visible = entries[0].isIntersecting;
            this.updatePlayback();
          }, { threshold: 0 });
          this.observer.observe(this);
        }
        this.updatePlayback();
      }
      pausePlayback() {
        if (!this.video.paused) {
          this.systemPause = true;
          this.video.pause();
        }
      }
      updatePlayback() {
        if (!this.visible || document.hidden || !this.wantsPlayback) {
          this.pausePlayback();
          return;
        }
        if (!this.video.paused || this.pendingPlay) return;
        this.pendingPlay = this.video.play().catch(error => {
          if (error.name !== 'AbortError') this.wantsPlayback = false;
        }).finally(() => { this.pendingPlay = null; });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        if (this.video) this.pausePlayback();
        this.controller = null;
      }
    }
    customElements.define('gg-season-faq-video', SeasonFaqVideo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gg-jul-peel"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('gg-jul-peel'))customElements.define('gg-jul-peel',class extends HTMLElement{
 connectedCallback(){
  if(this.abort)return;
  this.abort=new AbortController();const signal=this.abort.signal;
  this.cards=[...this.querySelectorAll('.jp-card')];this.playable=this.cards.filter(c=>c.querySelector('[data-layer-index]'));
  if(!this.playable.length)return;
  this.progress=this.querySelector('[data-progress]');this.completion=this.querySelector('[data-completion]');this.started=false;this.completed=new Set();
  this.setAttribute('data-enhanced','');this.querySelectorAll('[data-interactive],[data-restart]').forEach(e=>e.hidden=false);
  this.playable.forEach(c=>{c.querySelector('[data-parcel]').hidden=false;c.querySelector('[data-paper]').hidden=false;c.querySelector('[data-layers]').hidden=false;c.querySelectorAll('[data-fact]').forEach(f=>f.hidden=true);});
  this.cards.filter(c=>!this.playable.includes(c)).forEach(c=>c.querySelector('[data-result]').setAttribute('data-revealed',''));
  this.dots=this.querySelector('[data-progress-dots]');if(this.dots){this.dots.replaceChildren(...this.playable.map((c,i)=>{const dot=document.createElement('span');dot.textContent=i+1;return dot;}));if(!this.progress)this.dots.hidden=true;}
  this.completion.hidden=true;if(this.progress)this.progress.hidden=false;this.update();
  this.addEventListener('click',e=>{
   const layer=e.target.closest('[data-layer-index]');if(layer)this.removeLayer(layer);
   if(e.target.closest('[data-restart]'))this.reset();
   const cta=e.target.closest('[data-product-cta]');if(cta)this.emit('product_cta_clicked',cta.closest('.jp-card'));
   if(e.target.closest('[data-collection-cta]'))this.emit('collection_cta_clicked');
  },{signal});
  this.addEventListener('pointerdown',e=>{const button=e.target.closest('[data-layer-index]');if(button&&e.isPrimary&&e.button===0){this.pointer={button,x:e.clientX,y:e.clientY,id:e.pointerId};if(button.hasPointerCapture&&e.pointerId>0){try{button.setPointerCapture(e.pointerId);}catch{}}}},{signal});
  this.addEventListener('pointermove',e=>{const p=this.pointer;if(!p||p.id!==e.pointerId)return;const x=e.clientX-p.x,y=e.clientY-p.y;if(Math.abs(x)>8&&Math.abs(x)>Math.abs(y)){p.button.setAttribute('data-dragging','');p.button.style.setProperty('--jp-drag',x+'px');}},{signal});
  this.addEventListener('pointerup',e=>{const p=this.pointer;this.clearDrag();if(p&&p.id===e.pointerId&&Math.abs(e.clientX-p.x)>55&&Math.abs(e.clientY-p.y)<50)this.removeLayer(p.button);},{signal});
  this.addEventListener('pointercancel',()=>this.clearDrag(),{signal});
  this.querySelectorAll('details').forEach(d=>d.addEventListener('toggle',()=>{if(d.open)this.emit('ingredient_details_opened',d.closest('.jp-card'));},{signal}));
 }
 disconnectedCallback(){this.abort?.abort();this.abort=null;this.clearDrag();}
 clearDrag(){if(this.pointer){this.pointer.button.style.removeProperty('--jp-drag');this.pointer.button.removeAttribute('data-dragging');}this.pointer=null;}
 emit(action,card,layer){
  if(window.Shopify?.designMode)return;
  const detail={component:'gg_jul_peel',action,section_id:this.dataset.sectionId,product_id:card?.dataset.productId||null,product_handle:card?.dataset.productHandle||null,block_id:card?.dataset.blockId||null,block_index:card?Number(card.dataset.blockIndex):null,layer_index:layer?Number(layer.dataset.layerIndex):null};
  this.dispatchEvent(new CustomEvent('gg:jul-discovery',{bubbles:true,detail}));
 }
 removeLayer(button){
  if(button.hidden)return;
  const card=button.closest('.jp-card');if(!this.started){this.started=true;this.emit('interaction_started',card,button);}
  button.hidden=true;card.querySelectorAll('[data-fact]').forEach(f=>f.hidden=true);const fact=card.querySelector('[data-fact="'+button.dataset.layerIndex+'"]');if(fact)fact.hidden=false;this.emit('layer_removed',card,button);
  const next=[...card.querySelectorAll('[data-layer-index]')].find(b=>!b.hidden);
  if(next){next.focus({preventScroll:true});return;}
  this.completed.add(card);card.classList.add('is-unwrapped');card.querySelectorAll('[data-fact]').forEach(f=>f.hidden=true);const result=card.querySelector('[data-result]');result.setAttribute('data-revealed','');result.focus({preventScroll:true});
  this.emit('product_completed',card);this.update();
  if(this.completed.size===this.playable.length){this.completion.hidden=false;this.emit('all_products_completed');}
 }
 update(){if(this.progress)this.progress.textContent=this.progress.dataset.format.replace('[count]',this.completed.size).replace('[total]',this.playable.length);if(this.dots)[...this.dots.children].forEach((dot,i)=>{const done=this.completed.has(this.playable[i]);dot.className=done?'is-done ggicon':'';dot.textContent=done?'Q':i+1;});}
 reset(){
  this.started=false;this.completed.clear();this.completion.hidden=true;
  this.playable.forEach(card=>{card.classList.remove('is-unwrapped');card.querySelectorAll('[data-layer-index]').forEach(b=>b.hidden=false);card.querySelectorAll('[data-fact]').forEach(f=>f.hidden=true);card.querySelector('[data-result]').removeAttribute('data-revealed');});this.update();this.playable[0]?.querySelector('[data-layer-index]').focus({preventScroll:false});
 }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gg-jul-snow"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('gg-jul-snow'))customElements.define('gg-jul-snow',class extends HTMLElement{
 connectedCallback(){
  if(this.abort)return;
  this.abort=new AbortController();const signal=this.abort.signal;
  this.canvas=this.querySelector('canvas');this.context=this.canvas.getContext('2d');if(!this.context)return;
  this.round=this.dataset.shape==='round';this.sprite=document.createElement('canvas');this.sprite.width=64;this.sprite.height=64;const spriteContext=this.sprite.getContext('2d');spriteContext.fillStyle=this.dataset.color;spriteContext.translate((64-760.1*64/799.9)/2,0);spriteContext.scale(64/799.9,64/799.9);spriteContext.fill(new Path2D(this.querySelector('[data-snow-shape] path').getAttribute('d')));
  this.button=this.querySelector('button');this.hero=document.querySelector('main .gs-hero');
  this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.paused=false;this.frame=0;this.last=0;this.phase=0;
  this.resize=()=>{this.width=innerWidth;this.height=innerHeight;const dpr=Math.min(devicePixelRatio||1,2);this.canvas.width=Math.round(this.width*dpr);this.canvas.height=Math.round(this.height*dpr);this.context.setTransform(dpr,0,0,dpr,0,0);const count=Math.max(4,Math.round(Number(this.dataset.amount)*(this.width<750?.55:1)));this.flakes=Array.from({length:count},()=>({x:Math.random()*this.width,y:Math.random()*this.height,r:this.round?2+Math.random()*3:10+Math.random()*12,v:.7+Math.random()*.7,phase:Math.random()*Math.PI*2}));this.sync();};
  this.sync=()=>{this.hero=this.hero||document.querySelector('main .gs-hero');const heroTop=this.hero?.getBoundingClientRect().top||0;const media=this.hero?.querySelector('.gs-slide-media');const controlTop=(media?.getBoundingClientRect().height?media.getBoundingClientRect().top:heroTop)+16;if(this.button){this.button.style.top=controlTop+'px';this.button.hidden=controlTop<(innerWidth<750?84:124)||controlTop>innerHeight-36;}const travelled=Math.max(0,-heroTop);this.fade=Math.max(0,1-travelled/Number(this.dataset.distance));this.hidden=this.motion.matches||this.fade<=.01;this.canvas.style.opacity=String(this.fade*Number(this.dataset.opacity)/100);const run=!this.hidden&&!document.hidden&&!this.paused;if(run&&!this.frame){this.last=0;this.frame=requestAnimationFrame(t=>this.tick(t));}else if(!run){cancelAnimationFrame(this.frame);this.frame=0;}if(this.paused)this.context.clearRect(0,0,this.width,this.height);};
  this.button?.addEventListener('click',()=>{this.paused=!this.paused;this.button.textContent=this.paused?this.button.dataset.resume:this.button.dataset.pause;this.button.setAttribute('aria-pressed',String(this.paused));this.sync();},{signal});
  window.addEventListener('resize',this.resize,{passive:true,signal});document.addEventListener('scroll',this.sync,{passive:true,capture:true,signal});document.addEventListener('visibilitychange',this.sync,{signal});this.motion.addEventListener('change',this.sync,{signal});
  this.resize();
 }
 tick(time){
  this.frame=0;if(this.hidden||this.paused||document.hidden)return;
  const dt=this.last?Math.min((time-this.last)/1000,.05):0;this.last=time;this.phase+=dt;
  const ctx=this.context;ctx.clearRect(0,0,this.width,this.height);ctx.fillStyle=this.dataset.color;
  for(const f of this.flakes){f.y+=Number(this.dataset.speed)*f.v*dt;f.x+=Math.sin(this.phase*.4+f.phase)*5*dt;if(f.y>this.height+24){f.y=-24;f.x=Math.random()*this.width;}if(f.x< -24)f.x=this.width+24;if(f.x>this.width+24)f.x=-24;ctx.globalAlpha=.45+f.v*.3;if(this.round){ctx.beginPath();ctx.arc(f.x,f.y,f.r/2,0,Math.PI*2);ctx.fill();}else{ctx.drawImage(this.sprite,f.x-f.r/2,f.y-f.r/2,f.r,f.r);}}ctx.globalAlpha=1;
  this.frame=requestAnimationFrame(t=>this.tick(t));
 }
 disconnectedCallback(){this.abort?.abort();this.abort=null;cancelAnimationFrame(this.frame);this.frame=0;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gg-jul-story"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('gg-recipe-timer'))customElements.define('gg-recipe-timer',class extends HTMLElement{
connectedCallback(){if(this.events)return;this.events=new AbortController();const signal=this.events.signal;this.input=this.querySelector('input');this.display=this.querySelector('output');this.start=this.querySelector('[data-timer-start]');this.status=this.querySelector('[data-timer-status]');this.remaining=Number(this.input.value)*60;this.running=false;this.render();
this.input.addEventListener('change',()=>{if(!this.running){this.remaining=this.minutes()*60;this.removeAttribute('data-finished');this.status.textContent='';this.render()}},{signal});
this.start.addEventListener('click',()=>{if(this.running){this.remaining=Math.max(0,Math.ceil((this.deadline-Date.now())/1000));this.running=false;this.input.disabled=false;this.status.textContent='Timern är pausad.';this.render();return}if(!this.remaining)this.remaining=this.minutes()*60;try{this.audio ||= new (window.AudioContext||window.webkitAudioContext)();this.audio.resume().catch(()=>{})}catch{}this.deadline=Date.now()+this.remaining*1000;this.running=true;this.input.disabled=true;this.removeAttribute('data-finished');this.status.textContent='Timern är igång.';this.render()},{signal});
this.querySelector('[data-timer-reset]').addEventListener('click',()=>{this.running=false;this.input.disabled=false;this.remaining=this.minutes()*60;this.removeAttribute('data-finished');this.status.textContent='Timern är återställd.';this.render()},{signal});
this.interval=setInterval(()=>this.tick(),250);document.addEventListener('visibilitychange',()=>this.tick(),{signal});
}
minutes(){const n=Math.max(1,Math.min(240,Math.round(Number(this.input.value)||5)));this.input.value=n;return n}
tick(){if(!this.running)return;this.remaining=Math.max(0,Math.ceil((this.deadline-Date.now())/1000));if(!this.remaining){this.running=false;this.input.disabled=false;this.setAttribute('data-finished','');this.status.textContent='Tiden är ute – kontrollera maten!';this.beep()}this.render()}
render(){const n=this.remaining;this.display.textContent=[Math.floor(n/3600),Math.floor(n%3600/60),n%60].map(v=>String(v).padStart(2,'0')).join(':');this.start.textContent=this.running?'Pausa':this.remaining===this.minutes()*60?'Starta timer':this.remaining?'Fortsätt':'Starta igen'}
beep(){try{if(!this.audio)return;for(let i=0;i<3;i++){const o=this.audio.createOscillator(),g=this.audio.createGain(),t=this.audio.currentTime+i*.35;o.frequency.value=880;g.gain.setValueAtTime(.12,t);g.gain.exponentialRampToValueAtTime(.001,t+.22);o.connect(g);g.connect(this.audio.destination);o.start(t);o.stop(t+.25)}}catch{}}
disconnectedCallback(){clearInterval(this.interval);this.events?.abort();this.events=null;this.audio?.close().catch(()=>{});this.audio=null}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gg-jul-tree"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('gg-jul-tree'))customElements.define('gg-jul-tree',class extends HTMLElement{
connectedCallback(){if(this.events)return;this.events=new AbortController();const signal=this.events.signal;this.dialogs=[...this.querySelectorAll('dialog:not(.jt-reward)')];this.reward=this.querySelector('.jt-reward');this.gift=this.querySelector('[data-gift]');this.seen=new Set();const scene=this.querySelector('.jt-scene'),guide=this.querySelector('.jt-guide');this.fitTree=()=>{const ratio=getComputedStyle(scene).aspectRatio.split('/').map(Number);scene.style.setProperty('--jt-fit-width',((guide.offsetHeight+40)*(ratio[0]/(ratio[1]||1)))+'px')};this.guideResize=new ResizeObserver(this.fitTree);this.guideResize.observe(guide);this.setAttribute('data-enhanced','');this.querySelector('.jt-spots').hidden=false;this.progress=this.querySelector('[data-progress]');this.progress.hidden=false;this.update();this.fitTree();this.setupPositionEditor();this.addEventListener('submit',e=>{const form=e.target;if(!form.matches('.jt-reward-form'))return;e.preventDefault();this.addGift(form)},{signal});this.addEventListener('click',e=>{if(e.target.closest('[data-preview-reward]')){this.reward?.showModal();return}if(e.target.closest('[data-gift]')&&this.seen.size===this.dialogs.length){this.reward?.showModal();return}const open=e.target.closest('[data-open]');if(open&&this.hasAttribute('data-position-edit'))return;if(open){this.open(open.dataset.open,open);return}if(e.target.closest('[data-close]'))e.target.closest('dialog').close();const next=e.target.closest('[data-next]');if(next){const n=Number(next.dataset.next)+1;next.closest('dialog').close();if(this.dialogs[n])this.open(this.dialogs[n].id,this.querySelector('.jt-ornament[data-open="'+this.dialogs[n].id+'"]'));}},{signal});this.dialogs.forEach(d=>{d.addEventListener('click',e=>{const r=d.getBoundingClientRect();if(e.target===d&&(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom))d.close()},{signal});d.addEventListener('close',()=>{this.querySelectorAll('[data-open="'+d.id+'"]').forEach(b=>b.setAttribute('aria-expanded','false'));if(!this.dialogs.some(x=>x.open)){if(this.seen.size===this.dialogs.length&&!this.rewardShown&&this.reward){this.rewardShown=true;this.setAttribute('data-complete','');if(this.gift){this.gift.disabled=false;this.gift.setAttribute('aria-label','Öppna julens hemlighet')}this.reward.showModal()}else this.trigger?.focus({preventScroll:true})}},{signal})});this.reward?.addEventListener('close',()=>this.gift?.focus({preventScroll:true}),{signal});document.addEventListener('click',e=>{if(!e.target.closest('[data-open]')&&!e.target.closest('.jt-card'))this.dialogs.forEach(d=>{if(d.open)d.close()})},{signal});document.addEventListener('keydown',e=>{if(e.key==='Escape')this.dialogs.forEach(d=>{if(d.open)d.close()})},{signal});window.addEventListener('resize',()=>{this.fitTree();this.dialogs.forEach(d=>{if(d.open)this.positionCard(d,this.trigger)})},{signal});document.addEventListener('scroll',()=>this.dialogs.forEach(d=>{if(d.open)this.positionCard(d,this.trigger)}),{signal,capture:true});this.addEventListener('shopify:block:select',e=>{const b=e.target.closest('[data-open]');if(b&&!this.hasAttribute('data-position-edit'))this.open(b.dataset.open,b)},{signal});}
async addGift(form){
  if(form.dataset.submitting==='true')return;
  const button=form.querySelector('.jt-reward-add'),status=form.querySelector('.jt-reward-status');
  if(!button||!status)return;
  const body=new FormData(form);
  form.dataset.submitting='true';
  form.setAttribute('aria-busy','true');
  button.disabled=true;
  status.hidden=true;
  const root=window.Shopify?.routes?.root||'/';
  try{
    const response=await fetch(root+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body});
    const result=await response.json();
    if(!response.ok||result.status)throw new Error(result.description||result.message||status.dataset.error);
    let cart;
    for(let attempt=0;attempt<2&&!cart;attempt++){
      try{
        const cartResponse=await fetch(root+'cart.js',{headers:{Accept:'application/json'},cache:'no-store'});
        if(cartResponse.ok)cart=await cartResponse.json();
      }catch{}
    }
    document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:cart,sourceId:body.get('id'),data:{source:'gg-jul-tree',variantId:body.get('id')}}}));
    status.textContent=status.dataset.success;
  }catch(error){
    status.textContent=error.message||status.dataset.error;
  }finally{
    status.hidden=false;
    button.disabled=false;
    form.removeAttribute('aria-busy');
    delete form.dataset.submitting;
  }
}

open(id,trigger){const d=this.dialogs.find(x=>x.id===id);if(!d)return;this.dialogs.forEach(x=>{if(x.open)x.close()});this.trigger=trigger;this.seen.add(id);this.querySelectorAll('[data-open="'+id+'"]').forEach(b=>{b.dataset.seen='';const number=b.querySelector('.jt-list-number');if(number)number.textContent=''});this.update();d.show();this.positionCard(d,trigger);this.querySelectorAll('[data-open="'+id+'"]').forEach(b=>b.setAttribute('aria-expanded','true'));d.querySelector('[data-close]')?.focus({preventScroll:true});}

setupPositionEditor(){
const launch=this.querySelector('[data-edit-points]');if(!launch)return;
const signal=this.events.signal,scene=this.querySelector('.jt-scene'),points=[...this.querySelectorAll('.jt-ornament')],output=this.querySelector('[data-position-output]'),status=this.querySelector('[data-position-status]');
const baseline=points.map(p=>[p.style.getPropertyValue('--x'),p.style.getPropertyValue('--y')]);
const update=()=>{output.value=points.map(p=>p.dataset.pointId+':'+parseFloat(p.style.getPropertyValue('--x'))+','+parseFloat(p.style.getPropertyValue('--y'))).join(';');status.textContent='Placeringarna är ett utkast. Klistra in dem i Punktplaceringar och spara temat.'};
launch.addEventListener('click',()=>{const active=this.toggleAttribute('data-position-edit');this.querySelector('[data-position-controls]').hidden=!active;launch.textContent=active?'Avsluta placering':'Placera punkter';this.dialogs.forEach(d=>d.close());update()},{signal});
points.forEach(p=>{let drag=null;const move=e=>{if(!drag||drag.id!==e.pointerId)return;const r=scene.getBoundingClientRect();p.style.setProperty('--x',Math.max(5,Math.min(95,Math.round((e.clientX-r.left-drag.x)/r.width*100)))+'%');p.style.setProperty('--y',Math.max(3,Math.min(94,Math.round((e.clientY-r.top-drag.y)/r.height*100)))+'%');update()};
p.addEventListener('pointerdown',e=>{if(!this.hasAttribute('data-position-edit')||e.button!==0)return;e.preventDefault();const r=p.getBoundingClientRect();drag={id:e.pointerId,x:e.clientX-r.left-r.width/2,y:e.clientY-r.top-r.height/2};p.setPointerCapture(e.pointerId)},{signal});
p.addEventListener('pointermove',move,{signal});p.addEventListener('pointerup',e=>{move(e);drag=null},{signal});p.addEventListener('pointercancel',()=>drag=null,{signal});p.addEventListener('lostpointercapture',()=>drag=null,{signal});
p.addEventListener('keydown',e=>{if(!this.hasAttribute('data-position-edit'))return;const ds={ArrowLeft:[-1,0],ArrowRight:[1,0],ArrowUp:[0,-1],ArrowDown:[0,1]},v=ds[e.key];if(!v)return;e.preventDefault();const step=e.shiftKey?5:1;p.style.setProperty('--x',Math.max(5,Math.min(95,parseFloat(p.style.getPropertyValue('--x'))+v[0]*step))+'%');p.style.setProperty('--y',Math.max(3,Math.min(94,parseFloat(p.style.getPropertyValue('--y'))+v[1]*step))+'%');update()},{signal})});
this.querySelector('[data-reset-positions]').addEventListener('click',()=>{points.forEach((p,i)=>{p.style.setProperty('--x',baseline[i][0]);p.style.setProperty('--y',baseline[i][1])});update()},{signal});
this.querySelector('[data-copy-positions]').addEventListener('click',async()=>{output.focus();output.select();try{if(!document.execCommand('copy'))await navigator.clipboard.writeText(output.value);status.textContent='Kopierat! Klistra in i Punktplaceringar och klicka på Spara.'}catch{status.textContent='Markera och kopiera värdena manuellt.'}},{signal});
}

positionCard(d,trigger){const r=trigger.getBoundingClientRect(),w=d.offsetWidth,h=d.offsetHeight;const left=Math.max(12,Math.min(innerWidth-w-12,r.left+r.width/2-w/2));let top=r.top-h-10;if(top<12)top=r.bottom+10;top=Math.max(12,Math.min(innerHeight-h-12,top));d.style.left=left+'px';d.style.top=top+'px'}
update(){this.progress.textContent=this.progress.dataset.format.replace('[count]',this.seen.size).replace('[total]',this.dialogs.length)}
disconnectedCallback(){this.guideResize?.disconnect();this.reward?.close();this.dialogs?.forEach(d=>{if(d.open)d.close()});this.events?.abort();this.events=null;}
});

if(!customElements.get('gg-tree-snow'))customElements.define('gg-tree-snow',class extends HTMLElement{
connectedCallback(){if(this.events)return;this.events=new AbortController();this.paused=false;this.visible=false;this.motion=matchMedia('(prefers-reduced-motion: reduce)');const signal=this.events.signal;this.button=this.querySelector('button');if(this.button){this.button.hidden=false;this.button.addEventListener('click',()=>{this.paused=!this.paused;this.button.textContent=this.paused?'Snö · starta':'Snö · pausa';this.button.setAttribute('aria-pressed',String(this.paused));this.button.setAttribute('aria-label',this.paused?'Starta snöfallet i granavsnittet':'Pausa snöfallet i granavsnittet');this.updateSnow()},{signal})}this.resize=new ResizeObserver(()=>this.style.setProperty('--snow-travel',(this.clientHeight+24)+'px'));this.resize.observe(this);this.visibility=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.updateSnow()});this.visibility.observe(this);this.motion.addEventListener('change',()=>this.updateSnow(),{signal});document.addEventListener('visibilitychange',()=>this.updateSnow(),{signal});}
updateSnow(){this.toggleAttribute('data-running',this.visible&&!this.paused&&!this.motion.matches&&!document.hidden)}
disconnectedCallback(){this.events?.abort();this.resize?.disconnect();this.visibility?.disconnect();this.events=null;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gg-matvalet-compass"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gg-matval')) {
  customElements.define('gg-matval', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const config = this.querySelector('[data-config]');
      if (!config) return;
      this.ready = true;
      this.c = JSON.parse(config.textContent);
      this.answers = Array(this.c.questions.length).fill(null);
      this.weights = Array(this.c.questions.length).fill(1);
      this.index = 0;
      this.onClick = event => {
        const shop=event.target.closest('[data-result-shop]');if(shop&&this.contains(shop)){this.updateRewardUI();return;}
        const b = event.target.closest('button');
        if (!b || !this.contains(b)) return;
        if (b.hasAttribute('data-answer')) this.answer(Number(b.dataset.answer));
        else if (b.hasAttribute('data-back') && this.index > 0) { this.index--; this.render(true); }
        else if (b.hasAttribute('data-skip')) { this.answers[this.index]=null; this.next(); }
        else if (b.hasAttribute('data-next') && this.answers[this.index]!==null) this.next();
        else if (b.hasAttribute('data-restart')) { this.code=null; this.answers.fill(null); this.weights.fill(1); this.index = 0; this.render(true); }
        else if (b.hasAttribute('data-share')) this.share();
        else if (b.hasAttribute('data-open-envelope')) this.openEnvelope();
        else if (b.hasAttribute('data-copy-code')) this.copy(this.code, this.el('code-status'), true);
      };
      this.addEventListener('click', this.onClick);
      this.el('important').addEventListener('change', event => { this.weights[this.index] = event.target.checked ? 2 : 1; });
      this.onBlockSelect=event=>{const i=this.c.questions.findIndex(q=>q.id===event.detail.blockId);if(i>=0){this.index=i;this.render(true);}};
      this.addEventListener('shopify:block:select',this.onBlockSelect);

      this.syncCampaignCopy();
      this.campaignTimer=setInterval(()=>{this.syncCampaignCopy();if(!this.el("result-panel").hidden)this.updateRewardUI();},15000);
      this.sectionLoaded=()=>this.syncCampaignCopy();document.addEventListener("shopify:section:load",this.sectionLoaded);
      this.buildMethod();
      this.render(false);
    }
    disconnectedCallback(){clearInterval(this.campaignTimer);document.removeEventListener("shopify:section:load",this.sectionLoaded);this.removeEventListener('click',this.onClick);this.removeEventListener('shopify:block:select',this.onBlockSelect);this.ready=false;}
    el(key) { return this.querySelector('[data-' + key + ']'); }
    label(key) { return this.c.labels[key]; }
    fill(key, args) { return Object.entries(args).reduce((s,[k,v]) => s.replaceAll('{' + k + '}', String(v)), this.label(key)); }
    buildMethod() {
      const host = this.el('method');
      const p = document.createElement('p'); p.textContent = this.label('scale'); host.append(p);
      const table = document.createElement('table');
      const caption = document.createElement('caption'); caption.textContent = this.label('profile'); table.append(caption);
      const head = document.createElement('thead'); const tr = document.createElement('tr');
      [this.label('profile'),...this.c.questions.map((_,i) => String(i+1))].forEach(text => { const th = document.createElement('th'); th.scope='col'; th.textContent=text; tr.append(th); });
      head.append(tr); table.append(head);
      const body = document.createElement('tbody');
      this.c.profiles.forEach(profile => { const row=document.createElement('tr'); const title=document.createElement('th'); title.scope='row';title.textContent=profile.name;row.append(title);profile.points.forEach(point=>{const td=document.createElement('td');td.textContent=point;row.append(td);});body.append(row); });
      table.append(body);host.append(table);
      const list=document.createElement('ol');this.c.questions.forEach(q=>{const li=document.createElement('li');li.textContent=q.text;list.append(li);});host.append(list);
    }
    render(focus) {
      this.el('result-panel').hidden = true;
      this.el('question-panel').hidden = false;
      const q=this.c.questions[this.index];
      if(!q){this.result();return;}
      this.querySelector('progress').max=this.c.questions.length;
      this.el('step').textContent=this.fill('step',{n:this.index+1,total:this.c.questions.length});
      this.querySelector('progress').value=this.index;
      const heading=this.el('question');
      heading.classList.toggle('mv-heading-gg',q.font==='gg');
      heading.toggleAttribute('data-mv-size',q.size>0);
      heading.toggleAttribute('data-mv-mobile-size',q.mobile>0);
      heading.style.setProperty('--mv-title-size',(q.size||0)+'px');
      heading.style.setProperty('--mv-title-mobile',(q.mobile||0)+'px');
      heading.style.setProperty('--mv-title-tracking',Math.max(-100,Math.min(500,q.tracking??20))/1000+'em');
      heading.textContent=q.text;
      this.el('help').textContent=q.help;
      this.el('important').checked=this.weights[this.index]===2;
      this.el('back').disabled=this.index===0;
      const options=this.querySelector('.mv-answers'); options.replaceChildren();
      for(let i=0;i<4;i++){const b=document.createElement('button');b.type='button';b.className='mv-answer';b.dataset.answer=i;b.textContent=q.answers[i];if(this.answers[this.index]===i){const mark=document.createElement('span');mark.className='ggicon';mark.setAttribute('aria-hidden','true');mark.textContent='Q';b.append(mark);}b.setAttribute('aria-pressed',String(this.answers[this.index]===i));options.append(b);}
      const selected=this.answers[this.index]!==null;
      this.el('next').disabled=!selected;this.el('next').textContent=this.label(this.index===this.c.questions.length-1?'finish':'next');
      this.el('selection-status').textContent=selected?this.label('selected'):'';
      this.el('learning').hidden=!selected || !q.explanation;this.el('explanation').textContent=selected?q.explanation:'';
      if(focus){this.el('question').focus({preventScroll:true});this.el('question-panel').scrollIntoView({block:'start',behavior:'auto'});}
    }
    answer(value) {
      this.answers[this.index]=value;
      this.render(false);
      const selected=this.querySelector('[data-answer="'+value+'"]');if(selected)selected.focus({preventScroll:true});
    }
    next() {
      this.index++;
      if(this.index<this.c.questions.length)this.render(true);else this.result();
    }
    result() {
      const count=this.answers.filter(a=>a!==null).length;
      this.el('question-panel').hidden=true;this.el('result-panel').hidden=false;
      this.el('results').replaceChildren();this.el('share-status').textContent='';
      this.el('result-context').textContent=this.fill('context',{n:count,total:this.c.questions.length});
      const scores=this.c.profiles.map((p,i)=>{
        let difference=0,total=0;
        this.answers.forEach((a,j)=>{if(a!==null){difference+=Math.abs(a-p.points[j])*this.weights[j];total+=this.weights[j];}});
        return {...p,id:i,score:total?Math.round(100*(1-difference/(3*total))):0};
      }).sort((a,b)=>b.score-a.score);
      this.scores=scores;this.code=null;
      this.ggScore=scores.find(p=>p.id===0)?.score||0;
      this.tier=this.c.tiers.filter(t=>this.ggScore>=t.threshold).sort((a,b)=>b.discount-a.discount)[0]||this.c.tiers[0];
      const winners=count?scores.filter(p=>p.score===scores[0].score):[];
      this.el('result-title').textContent=!count?this.label('none_title'):winners.length>1?this.label('tie_title'):scores[0].title;
      this.el('result-description').textContent=!count?this.label('none_description'):winners.length>1?this.label('tie_description')+' '+winners.map(p=>p.name).join(' · '):scores[0].description;
      if(count)scores.forEach(p=>{const row=document.createElement('div');row.className='mv-result-row';row.style.setProperty('--mv-profile-color','var(--mv-profile-'+p.id+')');const line=document.createElement('div');const name=document.createElement('span');name.textContent=p.name;const percent=document.createElement('span');percent.textContent=p.score+' %';line.append(name,percent);const bar=document.createElement('div');bar.className='mv-bar';bar.setAttribute('aria-hidden','true');const fill=document.createElement('span');fill.style.width=p.score+'%';bar.append(fill);row.append(line,bar);this.el('results').append(row);});
      const important=this.c.questions.filter((_,i)=>this.weights[i]===2 && this.answers[i]!==null).map(q=>q.text);
      this.el('result-reasons').textContent=count?(important.length?this.label('reason')+important.join(' '):this.label('no_reason')):'';
      this.el('share').hidden=!count;
      this.el('reward').hidden=true;this.el('open-envelope').hidden=false;this.el('code-status').textContent='';
      this.updateRewardUI();
      this.el('result-title').focus({preventScroll:true});this.el('result-panel').scrollIntoView({block:'start',behavior:'auto'});
    }
    campaignPhase(now=Date.now()) {
      const start=Date.parse(this.c.starts),end=Date.parse(this.c.ends);
      if(this.c.rewardMode!=='active'||!Number.isFinite(start)||!Number.isFinite(end)||start>=end)return 'off';
      return now<start?'before':now>=end?'after':'active';
    }
    syncCampaignCopy(){const phase=this.campaignPhase();document.querySelectorAll('[data-mv-campaign-copy]').forEach(el=>{const text=el.dataset[phase==='off'?'after':phase]||el.dataset.after;if(text&&el.textContent!==text)el.textContent=text;});}
    discountText(key){return this.c.campaignCopy[key].replaceAll('{discount}',String(this.tier.discount));}
    updateRewardUI(){
      const available=this.rewardAvailable(),phase=this.campaignPhase();
      const shop=this.el('result-shop');
      this.el('envelope').hidden=!available;
      shop.textContent=available?this.discountText('shop_discount'):this.c.campaignCopy.shop;
      shop.href='#matval-produkter';
      if(available){
        const code=this.codes()[0];const destination=new URL(location.href);destination.hash='matval-produkter';
        const redirect=destination.pathname+destination.search+destination.hash;
        shop.href='/discount/'+encodeURIComponent(code)+'?redirect='+encodeURIComponent(redirect);
        this.el('reward-title').textContent=this.discountText('title');
        this.el('envelope-intro').textContent=this.c.campaignCopy.intro;
      }else{this.el('reward').hidden=true;this.code=null;}
      this.el('reward-note').textContent=phase!=='active'?this.c.campaignCopy[phase]:this.answers.some(a=>a===null)?this.label('incomplete'):available?(this.tier.discount===25?this.c.campaignCopy.highest:this.c.campaignCopy.replay):this.c.campaignCopy.off;
    }
    rewardAvailable() {
      if(!this.c.questions.length || this.answers.some(a=>a===null))return false;
      if(this.c.rewardMode==='preview')return true;
      if(this.c.rewardMode!=='active')return false;
      const start=Date.parse(this.c.starts),end=Date.parse(this.c.ends),now=Date.now();
      return this.codes().length>0 && Boolean(this.c.terms?.trim()) && Number.isFinite(start) && Number.isFinite(end) && start<end && now>=start && now<end;
    }
    codes(){return (this.tier?.codes||'').split(/\r?\n/).map(s=>s.trim()).filter(Boolean);}
    openEnvelope() {
      if(!this.rewardAvailable()){this.el('envelope-intro').textContent=this.label('expired');this.el('open-envelope').hidden=true;return;}
      const demo=this.c.rewardMode==='preview';
      if(!demo && !this.code){const pool=this.codes();const random=new Uint32Array(1);crypto.getRandomValues(random);this.code=pool[Math.floor((random[0]/4294967296)*pool.length)];}
      this.el('code-label').textContent=demo?'':this.label('code_label');
      this.el('code').textContent=demo?this.fill('demo_code',{discount:this.tier.discount}):this.code;
      this.el('terms').textContent=demo?this.label('demo_terms'):this.c.terms;
      this.el('copy-code').hidden=demo;
      this.el('reward').hidden=false;this.el('open-envelope').hidden=true;
    }
    async copy(text,status,isCode=false) {
      try { await navigator.clipboard.writeText(text);status.textContent=this.label(isCode?'copied_code':'copied'); }
      catch { status.textContent=this.label('copy_fail')+' '+text; }
    }
    async share() {
      const winners=this.scores.filter(p=>p.score===this.scores[0].score);
      const text=this.fill('share_text',{name:winners.map(p=>p.name).join(' / '),score:this.scores[0].score});
      const url=new URL(location.href);url.hash='matval-kompass';
      if(url.searchParams.get('view')==='matvalet')url.searchParams.set('preview_theme_id',this.c.themeId);
      for(const key of [...url.searchParams.keys()])if(!['preview_theme_id','view'].includes(key))url.searchParams.delete(key);
      if(navigator.share){try{await navigator.share({title:'Gröna gårdar · Matvalet 2026',text,url:url.href});return;}catch(e){if(e.name==='AbortError')return;}}
      await this.copy(text+' '+url.href,this.el('share-status'));
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gg-matvalet-products"] && !Shopify.designMode) return;
  try {
    
function initMatvalProducts(root=document){root.querySelectorAll('.mv-products').forEach(section=>{const button=section.querySelector('[data-mv-expand-products]');if(!button||button.dataset.ready)return;button.dataset.ready='true';const extra=Array.from(section.querySelectorAll('[data-mv-extra-product]'));extra.forEach(item=>item.hidden=true);button.hidden=extra.length===0;button.addEventListener('click',()=>{const next=extra.filter(item=>item.hidden).slice(0,24);next.forEach(item=>item.hidden=false);button.hidden=!extra.some(item=>item.hidden);if(button.hidden&&next.length){const link=next[0].querySelector('a');if(link)link.focus({preventScroll:true});}});});}
initMatvalProducts();document.addEventListener('shopify:section:load',e=>initMatvalProducts(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gg-matvalet"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gg-matval')) {
  customElements.define('gg-matval', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const config = this.querySelector('[data-config]');
      if (!config) return;
      this.ready = true;
      this.c = JSON.parse(config.textContent);
      this.answers = Array(this.c.questions.length).fill(null);
      this.weights = Array(this.c.questions.length).fill(1);
      this.index = 0;
      this.onClick = event => {
        const b = event.target.closest('button');
        if (!b || !this.contains(b)) return;
        if (b.hasAttribute('data-answer')) this.answer(Number(b.dataset.answer));
        else if (b.hasAttribute('data-back') && this.index > 0) { this.index--; this.render(true); }
        else if (b.hasAttribute('data-skip')) this.answer(null);
        else if (b.hasAttribute('data-restart')) { this.answers.fill(null); this.weights.fill(1); this.index = 0; this.render(true); }
        else if (b.hasAttribute('data-share')) this.share();
        else if (b.hasAttribute('data-open-envelope')) this.openEnvelope();
        else if (b.hasAttribute('data-copy-code')) this.copy(this.code, this.el('code-status'), true);
      };
      this.addEventListener('click', this.onClick);
      this.el('important').addEventListener('change', event => { this.weights[this.index] = event.target.checked ? 2 : 1; });
      this.buildMethod();
      this.render(false);
    }
    el(key) { return this.querySelector('[data-' + key + ']'); }
    label(key) { return this.c.labels[key]; }
    fill(key, args) { return Object.entries(args).reduce((s,[k,v]) => s.replaceAll('{' + k + '}', String(v)), this.label(key)); }
    buildMethod() {
      const host = this.el('method');
      const p = document.createElement('p'); p.textContent = this.label('scale'); host.append(p);
      const table = document.createElement('table');
      const caption = document.createElement('caption'); caption.textContent = this.label('profile'); table.append(caption);
      const head = document.createElement('thead'); const tr = document.createElement('tr');
      [this.label('profile'),...this.c.questions.map((_,i) => String(i+1))].forEach(text => { const th = document.createElement('th'); th.scope='col'; th.textContent=text; tr.append(th); });
      head.append(tr); table.append(head);
      const body = document.createElement('tbody');
      this.c.profiles.forEach(profile => { const row=document.createElement('tr'); const title=document.createElement('th'); title.scope='row';title.textContent=profile.name;row.append(title);profile.points.forEach(point=>{const td=document.createElement('td');td.textContent=point;row.append(td);});body.append(row); });
      table.append(body);host.append(table);
      const list=document.createElement('ol');this.c.questions.forEach(q=>{const li=document.createElement('li');li.textContent=q.text;list.append(li);});host.append(list);
    }
    render(focus) {
      this.el('result-panel').hidden = true;
      this.el('question-panel').hidden = false;
      const q=this.c.questions[this.index];
      this.el('step').textContent=this.fill('step',{n:this.index+1,total:this.c.questions.length});
      this.querySelector('progress').value=this.index;
      this.el('question').textContent=q.text;
      this.el('help').textContent=q.help;
      this.el('important').checked=this.weights[this.index]===2;
      this.el('back').disabled=this.index===0;
      const options=this.querySelector('.mv-answers'); options.replaceChildren();
      for(let i=0;i<4;i++){const b=document.createElement('button');b.type='button';b.className='mv-answer';b.dataset.answer=i;b.textContent=this.label('answer'+i);b.setAttribute('aria-pressed',String(this.answers[this.index]===i));options.append(b);}
      if(focus){this.el('question').focus({preventScroll:true});this.el('question-panel').scrollIntoView({block:'start',behavior:'auto'});}
    }
    answer(value) {
      this.answers[this.index]=value;
      this.index++;
      if(this.index<this.c.questions.length)this.render(true);else this.result();
    }
    result() {
      const count=this.answers.filter(a=>a!==null).length;
      this.el('question-panel').hidden=true;this.el('result-panel').hidden=false;
      this.el('results').replaceChildren();this.el('share-status').textContent='';
      this.el('result-context').textContent=this.fill('context',{n:count});
      const scores=this.c.profiles.map((p,i)=>{
        let difference=0,total=0;
        this.answers.forEach((a,j)=>{if(a!==null){difference+=Math.abs(a-p.points[j])*this.weights[j];total+=this.weights[j];}});
        return {...p,id:i,score:total?Math.round(100*(1-difference/(3*total))):0};
      }).sort((a,b)=>b.score-a.score);
      this.scores=scores;
      const winners=count?scores.filter(p=>p.score===scores[0].score):[];
      this.el('result-title').textContent=!count?this.label('none_title'):winners.length>1?this.label('tie_title'):scores[0].title;
      this.el('result-description').textContent=!count?this.label('none_description'):winners.length>1?this.label('tie_description')+' '+winners.map(p=>p.name).join(' · '):scores[0].description;
      if(count)scores.forEach(p=>{const row=document.createElement('div');row.className='mv-result-row';const line=document.createElement('div');const name=document.createElement('span');name.textContent=p.name;const percent=document.createElement('span');percent.textContent=p.score+' %';line.append(name,percent);const bar=document.createElement('div');bar.className='mv-bar';bar.setAttribute('aria-hidden','true');const fill=document.createElement('span');fill.style.width=p.score+'%';bar.append(fill);row.append(line,bar);this.el('results').append(row);});
      const important=this.c.questions.filter((_,i)=>this.weights[i]===2 && this.answers[i]!==null).map(q=>q.text);
      this.el('result-reasons').textContent=count?(important.length?this.label('reason')+important.join(' '):this.label('no_reason')):'';
      this.el('share').hidden=!count;
      this.el('envelope').hidden=!count || !this.rewardAvailable();
      this.el('envelope-intro').textContent=this.label(this.c.rewardMode==='preview'?'demo_intro':'active_intro');
      this.el('reward').hidden=true;this.el('open-envelope').hidden=false;this.el('code-status').textContent='';
      this.el('result-title').focus({preventScroll:true});this.el('result-panel').scrollIntoView({block:'start',behavior:'auto'});
    }
    rewardAvailable() {
      if(this.c.rewardMode==='preview')return true;
      if(this.c.rewardMode!=='active')return false;
      const start=Date.parse(this.c.starts),end=Date.parse(this.c.ends),now=Date.now();
      return this.codes().length>0 && Boolean(this.c.terms?.trim()) && Number.isFinite(start) && Number.isFinite(end) && start<end && now>=start && now<end;
    }
    codes(){return (this.c.codes||'').split(/\r?\n/).map(s=>s.trim()).filter(Boolean);}
    openEnvelope() {
      if(!this.rewardAvailable()){this.el('envelope-intro').textContent=this.label('expired');this.el('open-envelope').hidden=true;return;}
      const demo=this.c.rewardMode==='preview';
      if(!demo && !this.code){const pool=this.codes();const random=new Uint32Array(1);crypto.getRandomValues(random);this.code=pool[Math.floor((random[0]/4294967296)*pool.length)];}
      this.el('code-label').textContent=demo?'':this.label('code_label');
      this.el('code').textContent=demo?this.label('demo_code'):this.code;
      this.el('terms').textContent=demo?this.label('demo_terms'):this.c.terms;
      this.el('copy-code').hidden=demo;
      this.el('reward').hidden=false;this.el('open-envelope').hidden=true;
    }
    async copy(text,status,isCode=false) {
      try { await navigator.clipboard.writeText(text);status.textContent=this.label(isCode?'copied_code':'copied'); }
      catch { status.textContent=this.label('copy_fail')+' '+text; }
    }
    async share() {
      const winners=this.scores.filter(p=>p.score===this.scores[0].score);
      const text=this.fill('share_text',{name:winners.map(p=>p.name).join(' / '),score:this.scores[0].score});
      const url=new URL(location.href);url.hash='matval-kompass';
      if(url.searchParams.get('view')==='matvalet')url.searchParams.set('preview_theme_id',this.c.themeId);
      for(const key of [...url.searchParams.keys()])if(!['preview_theme_id','view'].includes(key))url.searchParams.delete(key);
      if(navigator.share){try{await navigator.share({title:'Gröna gårdar · Matvalet 2026',text,url:url.href});return;}catch(e){if(e.name==='AbortError')return;}}
      await this.copy(text+' '+url.href,this.el('share-status'));
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gg-season-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gg-season-faq-video')) {
    class SeasonFaqVideo extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.wantsPlayback = !this.motion.matches;
        this.visible = !('IntersectionObserver' in window);
        this.video.muted = true;
        this.video.addEventListener('play', () => {
          this.wantsPlayback = true;
          if (!this.visible || document.hidden) this.pausePlayback();
        }, { signal });
        this.video.addEventListener('pause', () => {
          if (!this.systemPause) this.wantsPlayback = false;
          this.systemPause = false;
        }, { signal });
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) {
            this.wantsPlayback = false;
            this.pausePlayback();
          }
        }, { signal });
        document.addEventListener('visibilitychange', () => this.updatePlayback(), { signal });
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.visible = entries[0].isIntersecting;
            this.updatePlayback();
          }, { threshold: 0 });
          this.observer.observe(this);
        }
        this.updatePlayback();
      }
      pausePlayback() {
        if (!this.video.paused) {
          this.systemPause = true;
          this.video.pause();
        }
      }
      updatePlayback() {
        if (!this.visible || document.hidden || !this.wantsPlayback) {
          this.pausePlayback();
          return;
        }
        if (!this.video.paused || this.pendingPlay) return;
        this.pendingPlay = this.video.play().catch(error => {
          if (error.name !== 'AbortError') this.wantsPlayback = false;
        }).finally(() => { this.pendingPlay = null; });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        if (this.video) this.pausePlayback();
        this.controller = null;
      }
    }
    customElements.define('gg-season-faq-video', SeasonFaqVideo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
